var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operator-data_block"},[_c('p',{staticClass:"large_label"},[_vm._v("オペレーター情報")]),_c('TableBox',{attrs:{"is-with-header":false,"table-contents":_vm.operatorData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }